import { useMutation, useQueryClient } from "@tanstack/react-query";
import { blockUser, unblockUser } from "@/api/chats";
import { ChatsQueryKeys } from "@/tanstackQuery/queries/chats";

interface BlockUserVariables {
  userId: number;
  blocked: boolean;
}

export const useBlockUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ userId, blocked }: BlockUserVariables) =>
      blocked ? blockUser({ userId }) : unblockUser(userId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ChatsQueryKeys.Chats] });
      queryClient.invalidateQueries({
        queryKey: [ChatsQueryKeys.ChatsPaginated],
      });
    },
  });
};
